module.exports = __webpack_public_path__ + "img/btn2.31f062fa.png";